import { createAction } from 'redux-starter-kit';
import { requestStart, requestFailed, requestSucceded } from '../../../domain/requests/RequestActions';
import { get, post, request } from '../../../../utility/via-fetch';
import { putTaxRates, putTaxRate, removeTaxRate } from '../../../domain/taxes/taxRateActions';
import { addMessage } from '../../application/messageUiActions';
import viaIntl from '../../../../contexts/via-intl';


/**
 * An action that signifies a tax-rate is being edited.
 * @example dispatch(editPackage(package.code))
 */
export const editTaxRate = createAction('EDIT_TAX_RATE');

/**
 * An action that signifies a tax-rate is no longer being edited.
 * @example dispatch(cancelEditTaxRate())
 */
export const cancelEditTaxRate = createAction('CANCEL_EDIT_TAX_RATE');


/**
 * An action creator to signify that tax rates are being fetched.
 */
export const fetchAllTaxRates = createAction('FETCH_ALL_TAX_RATES');

export function requestAllTaxRates() {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchAllTaxRates.toString()));
    dispatch(fetchAllTaxRates(requestId));
    try {
      const taxRates = await get('/api/tax-rate');
      dispatch(putTaxRates(taxRates));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

/**
 * An Action marking a request to save a tax rate.
 */
export const saveTaxRate = createAction('SAVE_TAX_RATE');

/**
 * An action that saves a tax rate to server.
 */
export function requestSaveTaxRate(taxRate) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(saveTaxRate.toString()));
    dispatch(saveTaxRate(requestId));
    try {
      await post('/api/tax-rate', undefined, taxRate);
      dispatch(putTaxRate(taxRate));

      const { intl } = viaIntl;
      dispatch(addMessage('success', 'itemUpdated', { item: intl.formatMessage({ id: 'taxRate' }) }));
      dispatch(cancelEditTaxRate());
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
    }
  };
}

/**
 * An action creator signifying tax is being deleted.
 */
export const fetchDeleteTaxRate = createAction('FETCH_DELETE_TAX_RATE');

/**
 * A thunk for deleting an action on the server.
 */
export function requestDeleteTaxRate(taxRate) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(saveTaxRate.toString()));
    dispatch(fetchDeleteTaxRate(requestId));
    try {
      const timeMS = new Date(taxRate.dateFrom).getTime();
      await request('DELETE', `/api/tax-rate/${timeMS / 1000}`);
      dispatch(removeTaxRate(timeMS));
      const { intl } = viaIntl;
      dispatch(addMessage('success', 'terminated', { title: intl.formatMessage({ id: 'taxRate' }) }));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
    }
  }
}